import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/storage'

import React, { useState, useEffect } from "react";

import { useFirestoreDocData, useFirestoreDocDataOnce, useFirestore, SuspenseWithPerf, useFirestoreCollectionData } from 'reactfire';

export function useGamesData (ethAddress) {

    const [isLoading, setIsLoading] = useState(null);
    const [isError, setIsError] = useState(null);
    const [currentData, setCurrentData] = useState(null);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [maxPlayersData, setMaxPlayersData] = useState(null);

    
    const refGames = useFirestore()
    .collection('gamesData');

    const dataGames = useFirestoreCollectionData(refGames);

    useEffect(() => {

        console.log('Data Change', dataGames);

        if(dataGames.status === "loading"){
            setCurrentData(null);
            setHasLoaded(false);
        } else if(dataGames.status === "success"){
            if(dataGames.data){
                setCurrentData(dataGames.data);
            }

            setHasLoaded(true);
        }



    },[dataGames, dataGames.status])

    useEffect(() => {

        if(currentData !== null && currentData !== undefined){
            console.log(`Current Data`, currentData);

            //Update Max Players Data
            processMaxPlayers();

        }


    },[currentData])

    const processMaxPlayers = () => {
        //Current Max Data
        let currentMaxPlayersData = [];

        //Init Max Players Data
        if(maxPlayersData !== null){
            currentMaxPlayersData = maxPlayersData;
        }
        
        //Safety.. Redundant.. Oh well
        if(currentData !== null && currentData !== undefined){
            for(let gameData of currentData){
                //Set Max Players For Each Individual Game 
                currentMaxPlayersData[gameData.name] = gameData.maxPlayers;

            }
        }
        //Update The State
        setMaxPlayersData(currentMaxPlayersData);

    }

    return {
        data: currentData,
        hasLoaded: hasLoaded,
        maxPlayersData: maxPlayersData,
    }

}
